<template>
    <div>
        <!-- <public-menu></public-menu> -->
        <jiameng-content></jiameng-content>
        <!-- <public-footer></public-footer> -->
    </div>
</template>

<script>
// import Public_menu from "@/components/common/public-top"
import Jiameng_content from "@/components/jiameng/Index"
// import Footer from "../../components/Footer.vue"
export default {
    components:{
        // 'public-menu': Public_menu,
        'jiameng-content': Jiameng_content,
        // 'public-footer': Footer
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/jiameng/Index.vue